function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Cancel_Icon",
  fill: "#E2574C",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M22.1045458,14.9795459 L29.225446,7.8596895 C30.2099217,6.87282332 30.2099217,5.28155795 29.225446,4.29976129 L25.6649959,0.737298332 C24.6805202,-0.244498323 23.0890215,-0.247033082 22.1045458,0.737298332 L14.9811105,7.8596895 L7.8627455,0.74236785 C6.87573465,-0.244498323 5.28170087,-0.244498323 4.29722516,0.737298332 L0.736775079,4.29976129 C-0.247700634,5.28155795 -0.245165504,6.87789284 0.74184534,7.86222426 L7.86021036,14.9795459 L0.754239312,22.0841938 C-0.230236402,23.0685252 -0.230236402,24.6597905 0.754239312,25.644122 L4.31468939,29.2065849 C5.2991651,30.1883816 6.89066375,30.1909163 7.87513947,29.2065849 L14.9808288,22.1019371 L22.1369391,29.2595332 C23.12395,30.2463994 24.7179838,30.2463994 25.7024595,29.262068 L29.2629096,25.7021398 C30.2473853,24.7178084 30.2448501,23.1240082 29.2603744,22.1371421 L22.1045458,14.9795459 Z",
  id: "Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Cancel_Icon--withoutCircle.945264d1.svg";
export { SvgComponent as ReactComponent };